export const workspace = {
  routes: [
    {
      path: "/workspace/library/direct-collect-method",
      component: () => import("../workspace-library-direct-collect-method-view"),
    },
    {
      path: "/workspace/library/other-collect-method",
      component: () => import("../workspace-library-other-collect-method-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/direct-collect-method",
      component: () => import("../management-library-direct-collect-method-view"),
    },
    {
      path: "/management/other-collect-method",
      component: () => import("../management-library-other-collect-method-view"),
    },
  ],
};
